var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"not-found"},[_c('span',{staticClass:"not-found__text"},[_vm._v("404")]),_c('span',{staticClass:"not-found__text"},[_vm._v(_vm._s(_vm.$t('page_not_found')))]),_c('TJButton',{staticClass:"not-found__button",attrs:{"text":"Перейти в каталог","width":250},on:{"handler":_vm.goToMain}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }